export default __webpack_public_path__ + "static/superbetter-progress-f04a7ccd4c3342936b7c23d53b41d656.webp";